import React from 'react';
import {Table as BaseTable} from 'desktop/sports/nfl/players-list/tiers';

class Table extends BaseTable {}

export {Table};
